var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSyncAborted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 18.3333C7.78934 18.3353 5.66857 17.4579 4.10533 15.8947C2.5421 14.3315 1.66476 12.2107 1.66675 9.99996V9.83329C1.73491 6.49347 3.78992 3.51675 6.88872 2.26917C9.98752 1.02159 13.5318 1.74403 15.8951 4.10496C18.2805 6.48836 18.9944 10.0744 17.7037 13.1896C16.413 16.3049 13.3721 18.3353 10.0001 18.3333ZM10.0001 11.175L12.1584 13.3333L13.3334 12.1583L11.1751 9.99996L13.3334 7.84162L12.1584 6.66662L10.0001 8.82496L7.84175 6.66662L6.66675 7.84162L8.82509 9.99996L6.66675 12.1583L7.84175 13.3333L10.0001 11.1758V11.175Z",
    fill: "#CA4139"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyncAborted);
export default __webpack_public_path__ + "static/media/sync_aborted.a6cffa4ba28d1128b6df0925aa902c45.svg";
export { ForwardRef as ReactComponent };